




import { Component, Prop, Vue } from 'vue-property-decorator';
import LocaleService from "../services/LocaleService";

@Component({
    computed: {
        getText():string {
            return LocaleService.getValue(this.$store.state, this.$props.tag);
        }
    }
})
export default class LocaleText extends Vue {
    @Prop() private tag!: string;
}
